module.exports = __webpack_public_path__ + "static/media/studyProgramImage.d7210d8f.jpg";